import * as Sentry from "@sentry/remix";
import { environment, release } from "./sentry.json";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
  enabled: release !== "dev-release",
  debug: false,
  dsn: "https://f803780561d708cab679f9ad24581ac0@o4506784909099008.ingest.sentry.io/4506784914669568",
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  sampleRate: 1,
  normalizeDepth: 6,
  release,
  environment,
  // spotlight: process.env.NODE_ENV === "development",
  ignoreErrors: [
    "https://reactjs.org/docs/error-decoder.html?invariant=421", // This Suspense boundary received an update before it finished hydrating
    "https://reactjs.org/docs/error-decoder.html?invariant=423", // There was an error while hydrating.
    "https://reactjs.org/docs/error-decoder.html?invariant=425", // Text content does not match server-rendered HTML...
  ],

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.browserProfilingIntegration(),
    ...(environment === "production"
      ? [
          Sentry.replayIntegration({
            mask: [".mask"],
            unmask: [".unmask"],
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
            networkDetailAllowUrls: [window.location.origin],
            minReplayDuration: 1000 * 15,
          }),
        ]
      : []),
    Sentry.httpClientIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      useSentryUser: true,
      autoInject: false,
    }),
    Sentry.reportingObserverIntegration(),
  ],

  beforeSend(event, hint) {
    if (release === "dev-release") return event;

    return event;
  },
  attachStacktrace: true,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  profilesSampleRate: 0.5,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.8,
  replaysOnErrorSampleRate: 1.0,
});
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});

// if (process.env.NODE_ENV === "development") {
//   import("@spotlightjs/spotlight").then((Spotlight) =>
//     Spotlight.init({
//       injectImmediately: true,
//       integrations: [Spotlight.sentry(), Spotlight.console()],
//       anchor: "bottomLeft",
//     }),
//   );
// }
